import React, { useState } from 'react';
import styled from 'styled-components'
import { useHistory } from "react-router-dom";
import { Element } from 'react-scroll'


import BigCard from "../reusable/BigCard"
import MiddlePopup from "../reusable/MiddlePopup"



const Thankyou = (props) => {

  let history = useHistory();
  const [open, toggleOpen] = useState(true);

  return(
    <Wrapper>
      <MiddlePopup 
        open={open}
        onClose={()=>toggleOpen(false)}
        onAction={()=>toggleOpen(false)}
        actionText="OK"
        close={true}
        title="Thank you"
      >
        You are now signed up for the Minimaa newsletter.
      </MiddlePopup>
      <BigCard 
        onClick={()=>history.push("/community")} 
        cta="Learn more" 
        text="Online Art Exhibition Space for Artists and Galleries" 
        imgUrl="../../sculpture1.png" 
        mobileImgUrl="../../mobileSculpture1.png" 
      />
      <BigCard 
        onClick={()=>window.open("https://www.instagram.com/onlineartexhibitionspace")} 
        cta="Follow us on Instagram" 
        text="Our community has a certain je ne sais quoi about it." 
        imgUrl="../../sculpture2.png" 
      />
      <Element name="contact">
        <BigCard 
          onClick={()=>{window.location.href = "mailto:hello@minimaa.co"}} 
          cta="Get in touch" 
          text="Are you curious and would like to know more now?" 
          imgUrl="../../sculpture3.png" 
        />
      </Element>
    </Wrapper>
  )
}

export default Thankyou



const Wrapper = styled.div(props => ({
  margin:"0px 100px",
  "@media (max-width: 980px)": {
    margin:"0px 50px",
  },
  "@media (max-width: 650px)": {
    margin:"0px 16px",
  }
}));

